module.exports = __webpack_public_path__ + "img/pole-homepage-bottom-POLAND.0333cb20.jpg";